import { render } from "./Team_index.vue?vue&type=template&id=d1bfe7b0&scoped=true"
import script from "./Team_index.vue?vue&type=script&lang=js"
export * from "./Team_index.vue?vue&type=script&lang=js"

import "./Team_index.vue?vue&type=style&index=0&id=d1bfe7b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d1bfe7b0"

export default script